import { render, staticRenderFns } from "./backgroundcontact.vue?vue&type=template&id=46e2b1ff&scoped=true&"
import script from "./backgroundcontact.vue?vue&type=script&lang=js&"
export * from "./backgroundcontact.vue?vue&type=script&lang=js&"
import style0 from "./backgroundcontact.vue?vue&type=style&index=0&id=46e2b1ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e2b1ff",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VParallax } from 'vuetify/lib/components/VParallax';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VForm,VParallax,VRow,VSelect,VTextField,VTextarea})
